<script>
export default {
    props: {
        filters: Object
    },

    data: () => ({
        tags: [],
        states: [],
        dealerships: [],
        brands: [],
        models: [],
        excludeFiltersByTags: ["orderby", "page", "search", "search_word"],
        textFilters: [],
        filtersElements: null,
        areCatalogsLoaded: false
    }),

    watch: {
        filters: {
            handler(newValue, oldValue) {
                let vm = this;
                if(this.areCatalogsLoaded) vm.reloadFilters();
            },
            deep: true
        },
        areCatalogsLoaded: {
            handler() {
                this.reloadFilters()
            }
        }
    },

    async beforeCreate() {
        await this.$store.dispatch("catalogNewVehicle/getDealershipsStates");
        await this.$store.dispatch("catalogNewVehicle/getStatesDealerships");
        await this.$store.dispatch("catalogNewVehicle/getBrands");
        await this.$store.dispatch("catalogNewVehicle/getModels");
        this.states = this.getDealershipsStates();
        this.dealerships = this.getStatesDealerships();
        this.models = this.getModels();
        this.brands = this.getBrands();
        this.areCatalogsLoaded = true
    },
    methods: {
        setTag(filterName, value) {
            let vm = this;
            let data = value;

            //Filter values only arrays and numbers
            value = value.filter(function(filterValue) {
                return (
                    typeof filterValue == "number" ||
                    filterValue.trim().length > 0
                );
            });

            if (value.length > 0) {
                this.filtersElements = document.getElementById("main_filters");
                let element = this.filtersElements;
                this.dropdownFilterOpen(element, filterName);

                if (!vm.textFilters.includes(filterName)) {
                    if (filterName == "prices") {
                        vm.tags.push({
                            filter: filterName,
                            value: this.$store.state.catalog.priceFilterSelected
                        });
                    } else if(filterName == "kilometers"){
                        vm.tags.push({
                            filter: filterName,
                            value: this.$store.state.catalog.kilometerFilterSelected
                        });
                    }
                    else {
                        _.map(data, function(item) {
                            vm.tags.push({
                                filter: filterName,
                                value: item
                            });
                        });
                    }
                }
            }
        },

        getTitle(id, filterName) {
            let element = this.filtersElements;
            var title = "";
            id = this.sanitizeValue(id);

            if (
                element
                    .getElementsByTagName("input")
                    .namedItem(filterName + "-" + id)
            ) {
                title = element
                    .getElementsByTagName("input")
                    .namedItem(filterName + "-" + id).nextElementSibling
                    .innerText;
            } else {
                title = id;
            }

            if (filterName == "states") {
                let found = this.states.find(element => element.value == id);
                if (found != undefined) {
                    title = found.name;
                }
            }
            if (filterName == "dealerships") {
                let found = this.dealerships.find(element => element.value == id);
                if (found != undefined) {
                    title = found.name;
                }
            }

            if (filterName == "brands") {
                var brand = _.find(this.brands, function(brand) { return brand.value == id; });
                title = brand.name;
            }
            if (filterName == "prices") {
                const range = this.$store.state.catalogNewVehicle.priceRange;
                const priceSelected = this.$store.state.catalogNewVehicle.priceFilterSelected
                const price = _.find(range, function(price) { return price.value == priceSelected; })
                title = price.name;
            }
            if (filterName == "kilometers") {
                const range = this.$store.state.catalogNewVehicle.kilometersRange;
                const kilometerSelected = this.$store.state.catalogNewVehicle.kilometerFilterSelected
                const kilometer = _.find(range, function(kilometer) { return kilometer.value == kilometerSelected; })
                title = kilometer.name;
            }
            if (filterName == "types_car") {
                const types = this.$store.state.catalogNewVehicle.productType
                const vehicleType = _.find(types, function(type) { return type.vehicle_body_type == id; });
                title = vehicleType.vehicle_body_type;
            }
            return title;
        },
        getDealershipsStates() {
            return _.map(this.$store.state.catalogNewVehicle.states, function(item, key) {
                return {
                    name: item.name,
                    value: item.id
                };
            });
        },
        getStatesDealerships() {
            return _.map(this.$store.state.catalogNewVehicle.dealerships, function(item, key) {
                return {
                    name: item.name,
                    value: item.id
                };
            });
        },
        getBrands() {
            return _.map(this.$store.state.catalogNewVehicle.brands, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },
        getModels() {
            return _.map(this.$store.state.catalogNewVehicle.models, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getSearch() {
            var search = window.location.search;
            var urlParams = new URLSearchParams(window.location.search);

            let searchFilters = urlParams.get("search");

            if (!!searchFilters && searchFilters.trim().length > 0) {
                this.tags.push({
                    filter: "search",
                    value:
                        "Resultados de " + searchFilters.replace(/[%20]/gi, " ")
                });
            }
        },

        removeTag(id, filterName) {
            let element = this.filtersElements;
            id = this.sanitizeValue(id);
            this.dropdownFilterOpen(element, filterName);

            if (filterName == "prices") {
                this.$store.state.catalogNewVehicle.filters.prices.from = 0
                this.$store.state.catalogNewVehicle.filters.prices.to = 0
                this.$store.state.catalogNewVehicle.filters.prices.selected = 0
            } else if (filterName == "kilometers") {
                this.$store.state.catalogNewVehicle.filters.kilometers.from = 0
                this.$store.state.catalogNewVehicle.filters.kilometers.to = 0
                this.$store.state.catalogNewVehicle.filters.kilometers.selected = 0
            }
            else {
                element
                    .getElementsByTagName("input")
                    .namedItem(filterName + "-" + id)
                    .click();
            }
        },

        removeSearchTag() {
            this.filters.search = "";
        },

        reloadFilters() {
            let vm = this;
            let filtersActives = vm.filters;
            vm.clearTags();
            vm.getSearch();
            _.map(filtersActives, function(filterValue, filterName) {
                if (!vm.excludeFiltersByTags.includes(filterName)) {
                    var ArrayValues = _.map(filterValue, function(value, key) {
                        return vm.FilterTrueValue(value, key);
                    });
                    vm.setTag(filterName, ArrayValues);
                }
            });
        },

        dropdownFilterOpen(element, filterName) {
            var existsParent = !!element.getElementsByClassName(
                "trigger-" + filterName
            )[0];

            if (existsParent) {
                let filterIsOpen =
                    element.getElementsByClassName("trigger-" + filterName)[0]
                        .nextElementSibling.style.display == "block";

                if (!filterIsOpen) {
                    element
                        .getElementsByClassName("trigger-" + filterName)[0]
                        .click();
                }
            }

            return existsParent;
        },

        sanitizeValue(value) {
            // If had ":" get the filter name from first key
            if (String(value).indexOf(":") > -1) {
                var split = value.split(":");
                if (split[1].trim().length > 0 && split[1].trim() != "false") {
                    return value.split(":")[0];
                }
                return "";
            }

            return value;
        },

        showTitle(value, filter) {
            return this.getTitle(value, filter);
        },

        FilterTrueValue(arrayValue, arrayKey) {
            if (arrayValue === "false" || !arrayValue) {
                return "";
            }
            if (/^\d+$/.test(arrayKey)) {
                return arrayValue;
            }
            return arrayKey + ":" + arrayValue;
        },

        clearTags() {
            this.tags = [];
        }
    }
};
</script>

<template>
    <div>
        <ul class="list__filters__tags spacing-0 bullet-none flex flex-wrap">
            <template v-for="(tag, key) in tags">
                <li
                    :key="key"
                    v-if="showTitle(tag.value, tag.filter).trim().length > 0"
                    class="item"
                >
                    <span class="badge">
                        <span
                            class="tx-18 mr-3 md:mr-4 inline-block"
                            @click="
                                tag.filter != 'search'
                                    ? removeTag(tag.value, tag.filter)
                                    : removeSearchTag()
                            "
                        >
                            &times;
                        </span>
                        <span>
                            {{ showTitle(tag.value, tag.filter).trim() }}
                        </span>
                    </span>
                </li>
            </template>
        </ul>
    </div>
</template>
